import React, {FC, ReactElement, useMemo} from 'react';
import {routes} from "../Routes";
import BaseNavBar, {NavigationItemMenu, translateNavItems} from "../BaseNavBar";
import {ListItemIcon, ListItemText, MenuItem} from "@mui/material";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {selectedCompanyStore} from "../../store/SelectedCompany";
import {useTranslation} from "react-i18next";
import SettingsIcon from "@mui/icons-material/Settings";
import {SubscriptionMenuItem} from "../SubscriptionMenuItem";

const navigation: NavigationItemMenu[] = [
    {label: "Upload docs", path: routes.documentsUpload},
    {
        label: "Sales", path: routes.newSalesInvoice,
        items: [
            {label: "New invoice", path: routes.newSalesInvoice},
            {label: "My sales", path: routes.salesInvoices},
            {label: "My clients", path: routes.myClients},
        ]
    },
    {
        label: "My company", path: routes.myCompany,
        items: [
            {label: "Details", path: routes.myCompany},
        ]
    },
    {
        label: "Employees", path: routes.addEmployee,
        items: [
            {label: "New employee", path: routes.addEmployee},
        ]
    },
    // {label: "Advice", path: routes.advice},
    {
        label: "Knowledge base", path: routes.knowledgeBase,
        items: [
            {label: "Links", path: routes.knowledgeBase},
            {label: "Templates", path: routes.clientDocsTemplates},
        ]
    },
]

export const ClientNavBar: FC = (): ReactElement => {
    const location = useLocation();
    const navigate = useNavigate();
    const {t} = useTranslation();

    const translatedNav = useMemo(() => {
        return translateNavItems(navigation, t)
    }, [t])

    return <BaseNavBar
            location={location}
            navigate={navigate}
            userMenuItems={[
                <MenuItem disabled={!selectedCompanyStore.isSelected} component={Link}
                          to={routes.companySettings}>
                    <ListItemIcon>
                        <SettingsIcon/>
                    </ListItemIcon>
                    <ListItemText primary={t("user_menu.CompanySettings", "Company settings")}/>
                </MenuItem>,
                <SubscriptionMenuItem/>
            ]}
            navigationItems={translatedNav}
    />
}
